export class BaseComponent{
    componentType:string;
}